let audioLabelsPromise = null;

export const ensureAudioDeviceLabels = () => {
	if (!audioLabelsPromise) {
		audioLabelsPromise = navigator.mediaDevices
			? navigator.mediaDevices.getUserMedia({ audio: true })
				.then(stream => stream.getTracks().forEach(track => track.stop()))
				.catch(() => {})
			: Promise.resolve();
	}

	return audioLabelsPromise;
};
